<template>
  <div :class="clContainer()" @click="$event.stopPropagation()">
    <button @click="toggle" type="button">
      <img
        :class="clSub('bell', notificationsUnread.length ? 'ring' : '')"
        src="../../../img/icons/notifications.svg"
        alt="Notifications"
      />

      <span
        v-if="notifications.length"
        :class="clSub('badge', notificationsUnread.length ? 'unread' : 'read')"
      >
        {{
          notificationsUnread.length
            ? notificationsUnread.length
            : notifications.length
        }}
      </span>
    </button>

    <div v-if="opened && notifications.length" :class="clSub('list')">
      <header :class="clSub('list__header')">
        {{
          __("main.components.notifications.header", notifications.length, {
            count: notifications.length,
          })
        }}

        <button
          @click="removeAll"
          class="btn btn-xsmall btn-secondary btn-auto-width"
        >
          Alle löschen
        </button>
      </header>

      <ul :class="clSub('items')">
        <notification
          v-for="(notification, index) in notifications"
          :notification="notification"
          :index="index"
          :base-app-url="baseUrl"
          :icon-src="iconSrc"
          :base-class="clSub('item', '', false)"
          :key="notification.id"
          @remove="remove"
          @action="handleAction"
        >
        </notification>
      </ul>
    </div>
  </div>
</template>

<script>
import Notification from "./Notification";
import NeedsIcons from "../Mixins/NeedsIcons";
import NeedsSetableCssClasses from "../Mixins/NeedsSetableCssClasses";

export default {
  mixins: [NeedsIcons, NeedsSetableCssClasses],
  components: {
    notification: Notification,
  },
  props: {
    baseClass: {
      type: String,
      default: "notifications",
    },
    baseUrl: {
      type: String,
    },
    dataEndpoint: {
      type: String,
    },
    dataHandler: {
      type: Function,
    },
    newHandler: {
      type: Function,
    },
    persistentNotifications: {
      type: Array,
      default() {
        return [];
      },
    },
    actionHandler: {
      type: Object,
    },
  },
  data() {
    return {
      opened: false,
      notifications: [],
    };
  },
  mounted() {
    if (this.dataEndpoint != undefined) {
      this.bindToEndpoint();
    }
    this.$el.addEventListener("click", (ev) => {
      if (
        ev.target.tagName == "BUTTON" &&
        ev.target.getAttribute("data-action")
      ) {
        const notification = this.notifications.find(
          (n) => n.id == ev.target.getAttribute("data-notification")
        );

        this.callAction(ev.target.getAttribute("data-action"), notification);
      }
    });
  },
  updated() {
    if (this.opened) {
      document.body.addEventListener("click", this.toggle);
    } else {
      document.body.removeEventListener("click", this.toggle);
    }
  },
  beforeDestory() {
    if (this.sse && this.sse.readyState != 2) {
      this.sse.close();
    }
  },
  watch: {
    persistentNotifications: {
      immediate: true,
      handler(newPersistentNotifications) {
        const result = this.add(newPersistentNotifications);
        this.$emit("added", result);
      },
    },
  },
  computed: {
    notificationsUnread() {
      return this.notifications.filter((p) => !p.read);
    },
  },
  methods: {
    toggle() {
      this.opened = !this.opened;

      if (this.opened) {
        this.$emit("opened");
      } else {
        this.$emit("closed");

        if (this.notificationsUnread.length > 0) {
          this.$emit("closed-unread");

          for (let i = 0; i < this.notifications.length; i++) {
            if (!this.notifications[i].read) {
              this.$set(this.notifications[i], "read", true);

              if (this.dataHandler) {
                this.dataHandler.call(this, this.notifications[i], "read");
              }
            }
          }
        }
      }
    },
    add(newNotifications, source = "api") {
      if (!Array.isArray(newNotifications)) {
        newNotifications = newNotifications ? [newNotifications] : [];
      }
      if (!newNotifications.length) {
        return null;
      }

      const result = { all: [], added: [], updated: [] };

      if (this.newHandler) {
        this.newHandler(newNotifications, source);
      }

      for (let notification of newNotifications) {
        const existentIndex = this.notifications.findIndex(
          (n) => n.id == notification.id
        );

        notification = this.handleNewNotification(notification, source);

        if (existentIndex != -1) {
          this.notifications.splice(existentIndex, 1, notification);
          result.updated.push(notification);
        } else {
          this.notifications.unshift(notification);
          result.added.push(notification);
        }

        result.all.push(notification);
      }

      return result;
    },
    remove(index) {
      this.$emit("removed", this.notifications[index]);
      this.notifications.splice(index, 1);
    },
    removeAll() {
      this.$emit("removed-all");
      this.notifications = [];
    },
    handleNewNotification(notification, source) {
      notification.source = source;

      if ("actions" in notification && notification.actions) {
        // Generate action-links from defined actions for use in the translation files
        notification.actionLinks = {};

        Object.keys(notification.actions).forEach((key) => {
          const action = notification.actions[key];
          let actionLink = null;
          const labelKey = "label" in action ? action.label : key;
          if ("url" in action) {
            actionLink =
              `<a href="${action.url}">` +
              this.__(`main.notifications.actions.${labelKey}`, action) +
              "</a>";
          } else {
            actionLink =
              `<button data-action="${key}" data-notification="${notification.id}">` +
              this.__(
                `notifications.jobs.common.title.${notification.typeKey}`,
                action
              ) +
              "</button>";
          }

          notification.actionLinks[key] = actionLink;
        });
      }

      if (this.dataHandler) {
        notification = this.dataHandler.call(this, notification, "add");
      }

      return notification;
    },
    callAction(actionKey, notification) {
      const actionData = notification.actions[actionKey];

      this.handleAction({ notification, actionKey, actionData });
    },
    handleAction({ notification, actionKey, actionData }, toggleList = true) {
      if (
        actionData &&
        typeof actionData == "object" &&
        !("href" in actionData) &&
        this.actionHandler &&
        actionKey in this.actionHandler
      ) {
        this.actionHandler[actionKey](notification, actionData);
      }

      this.$emit("action", { notification, actionKey, actionData });

      if (toggleList) {
        this.toggle();
      }
    },
    bindToEndpoint() {
      let endpoint = this.dataEndpoint;
      let protocol = null;

      endpoint = endpoint.replace(/^([^:]+):\/\/(.+)$/, (match, p1, p2) => {
        protocol = p1[0].toUpperCase() + p1.slice(1);
        return p2;
      });

      if (protocol) {
        let bindMethod = "bindTo" + protocol;
        if (bindMethod in this && typeof this[bindMethod] == "function") {
          this[bindMethod](endpoint);
        }
      }
    },
    bindToSse(endpoint, sourceProtocol = "http") {
      this.sse = new EventSource(sourceProtocol + "://" + endpoint);

      this.sse.addEventListener("message", (event) => {
        if (typeof event == "object" && "data" in event) {
          const eventData = JSON.parse(event.data);

          if ("error" in eventData) {
            console.error(eventData.error);
          } else if ("data" in eventData) {
            if ("error" in eventData.data) {
              console.error(eventData.data.error);
            }

            if ("action" in eventData.data) {
              this.handleAction(
                {
                  notification: null,
                  actionKey: eventData.data.action,
                  actionData:
                    "actionData" in eventData.data
                      ? eventData.data.actionData
                      : null,
                },
                false
              );
            } else {
              this.add([eventData.data], "broadcast");
            }
          }
        }
      });
    },
    bindToSses(endpoint) {
      this.bindToSse(endpoint, "https");
    },
  },
};
</script>